import jwt from "jwt-decode";
export function jwtToken(token: string) {
  const user: any = jwt(token);
  user.userId = !isNaN(Number(user.userId)) ? 0 : parseInt(user.sub);
  user.roleId = !isNaN(Number(user.roleId)) ? 0 : parseInt(user.role);
  return user;
}
